import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAssetInsightMetric } from "../../../store/actions"; // Update with actual action
import { resourceIconMap } from "./AssetManagementInfoCard";

export const useAssetInsightData = (accCodes, orgCode) => {
  const dispatch = useDispatch();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const assetInsightMetric = useSelector(
    (state) => state.metricInfo.assetInsightMetric
  );
  const assetInsightMetricLoading = useSelector(
    (state) => state.metricInfo.assetInsightMetricLoading
  );
  const assetInsightMetricError = useSelector(
    (state) => state.metricInfo.assetInsightMetricError
  );

  // To track if the API call has already been made
  const hasFetchedData = useRef(false);

  useEffect(() => {
    if (accCodes.length > 0 && orgCode && !hasFetchedData.current) {
      console.log("Making API call for asset insight data");
      dispatch(getAssetInsightMetric(accCodes, orgCode)); // Dispatch the action
      hasFetchedData.current = true; // Mark the call as done
    } else {
      console.log("Skipping API call for asset insight data");
    }
  }, [dispatch, accCodes, orgCode]);

  useEffect(() => {
    if (assetInsightMetric) {
      // The API response is already in the correct format, no need for transformation
      // Just pass it directly to the component
      setData(assetInsightMetric);
    }
    setLoading(assetInsightMetricLoading);
    setError(assetInsightMetricError ? "Error in Asset Insight API" : null);
  }, [assetInsightMetric, assetInsightMetricLoading, assetInsightMetricError]);

  return { data, loading, error };
};

// This function is no longer needed as the API response format is already correct
// Keeping it for backward compatibility if needed
const apiDataToAssetInsightMetricObject = (apiData) => {
  // The API response is already in the correct format
  // Just return it as is
  return apiData;
};